import React, { useState, createContext, useContext } from 'react';
interface SidebarContextType {
  collapsed: boolean;
  toggle: () => void;
}
const SidebarContext = createContext<SidebarContextType>({
  collapsed: false,
  toggle: () => {}
});
export function SidebarProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [collapsed, setCollapsed] = useState(false);
  const toggle = () => setCollapsed(prev => !prev);
  return <SidebarContext.Provider value={{
    collapsed,
    toggle
  }} data-id="element-297">

      {children}
    </SidebarContext.Provider>;
}
export function useSidebar() {
  return useContext(SidebarContext);
}